import React from 'react';
import { FacilityPayerValidationModalTemplate } from 'themes/application/facility/components';
import { observer } from 'mobx-react';
import { FacilityPayerValidationModalStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityPayerValidationModalStore(rootStore, componentProps), 'facilityPayerValidationModalStore')
@observer
class FacilityPayerValidationModal extends React.Component {
    render() {
        return <FacilityPayerValidationModalTemplate {...this.props} />
    }
}

export default FacilityPayerValidationModal;
